import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import ENDPOINT from '../../data/ENDPOINT';
import SecurityHeaders from '../../data/SecurityHeaders';

const ToolsComponent = ({limit}) => {
  const [tools, setTools] = useState([]);
   
    const getAllHackingTools = async () => {
     
    try {
      const data =  new FormData();
    if(limit){
      data.append('limit', limit);
    }
      const response = await axios.post(ENDPOINT+'get-hacking-tools.php', data, SecurityHeaders);
      if(response) {
      if(response.data.status === "success") {
        setTools(response.data.data);
      }
      } else {
       
        console.error('Failed to fetch hacking tools');
      }}
      catch(error) {
        console.error('Error fetching hacking tools:', error);
      }
   
  
    }
    useEffect(() => {
      getAllHackingTools();
    }, []);
  return (
    
    <div className="">


<div className="d-flex flex-wrap text-white animate-fade animation-active ">

 
       {
           tools.map((tool,index) => (
        
            <Link to={'/tool-details/'+tool.id} className={"col-lg-3 col-6 p-2"+" fade-in-bottom "+"delay"+index+"s"}>


            <div className="shadow text-center rounded theme-border border bg-transparent bg-transparent">
              <img src={tool.image} className="w-100 rounded-top rounded-bottom-0"></img>
              <div className="p-3">
                <h4 className='text-dark'>{tool.title}</h4>
                <p className="truncate truncate3">{tool.description}</p>
              </div>
            </div>
  
          </Link>
         
          ))
       }
        


    </div>
    </div>




  )
}

export default ToolsComponent
